var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "appContainer",
    attrs: {
      "id": "app"
    }
  }, [_c('mobile_menu', {
    attrs: {
      "isMobileMenuOpened": _vm.openMobileMenuStatus && _vm.isInMobileView,
      "isLoggedIn": _vm.isLoggedIn,
      "isIndividual": _vm.isIndividual,
      "activeMenuItem": _vm.activeMobileMenuItem
    },
    on: {
      "close-mobile-menu-view": _vm.openMobileMenu,
      "send-announcement-text": _vm.showAnnouncementModal
    }
  }), _c('template_header', {
    attrs: {
      "isMobileMenuOpened": _vm.openMobileMenuStatus
    },
    on: {
      "open-mobile-menu": _vm.openMobileMenu,
      "set-user-authentication": _vm.setUserAuthenticationStatus,
      "send-active-mobile-menu-item": _vm.setMobileActiveMenuItem,
      "send-announcement-text": _vm.showAnnouncementModal
    }
  }), _c('router-view'), _c('template_footer'), _c('b-modal', {
    ref: "announcement-modal",
    attrs: {
      "title": "Project Spectrum Announcement",
      "centered": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('div', {
    staticClass: "modal-content text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.announcementText)
    }
  })]), _c('div', {
    staticClass: "mt-3 d-flex flex-row justify-content-center align-items-center"
  }, [_c('b-button', {
    key: "",
    staticClass: "modal-button",
    attrs: {
      "id": "input-3",
      "size": "lg"
    },
    on: {
      "click": _vm.hideAnnouncementModel
    }
  }, [_vm._v("OK ")])], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }